export default __webpack_public_path__ + "static/media/p7.71c20600.jpg";